import { defineStore } from 'pinia'
import type { AppState, Language } from './helper'
import { getLocalSetting, setLocalSetting } from './helper'
import { store } from '@/store'
import Cookies from 'js-cookie'

export const useAppStore = defineStore('app-store', {
    state: (): AppState => getLocalSetting(),
    actions: {
        // set language
        setLanguage(language: Language) {
            if (this.lang !== language) {
                this.lang = language
                Cookies.set('lang', language)
                this.direction = language === 'ar_SA' ? 'rtl' : 'ltr'
                this.recordState()
                window.location.reload()
            }
        },

        setDirection(direction: 'ltr' | 'rtl') {
            this.direction = direction
            this.recordState()
        },

        // record state
        recordState() {
            setLocalSetting(this.$state)
        },
    },
})

export function useAppStoreWithOut() {
    return useAppStore(store)
}